import type FullCalendar from '@fullcalendar/react'
import { useRef } from 'react'

/** Ref tipada para a API imperativa do calendário. */
export function useCalendarRef() {
    return useRef<FullCalendar>(null)
}
